import type { Lohnabrechnungsart as DatevServiceLohnabrechnungsart } from '../../../datev-service/gql/graphql';

export const lohnabrechnungsart = {
  LODAS: 'LODAS',
  LOGE: 'LOGE',
} as const;

export type Lohnabrechnungsart = keyof typeof lohnabrechnungsart;

export const datevServiceLohnabrechnungsart: Record<
  Lohnabrechnungsart,
  DatevServiceLohnabrechnungsart
> = {
  LODAS: 'lodas',
  LOGE: 'lug',
};
